// Turn an admin-entered URL into a safe external link, or null if unusable.
// Accepts "https://…", "http://…", or a bare host like "github.com/user/repo";
// rejects empty values and other schemes (e.g. "javascript:").
export const toExternalUrl = (value) => {
  const url = typeof value === 'string' ? value.trim() : '';
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  if (/^[a-z][a-z0-9+.-]*:/i.test(url)) return null;
  return `https://${url}`;
};

// Project tech is stored as an array, but older docs may hold a
// comma-separated string or nothing at all.
export const toTechList = (tech) => {
  if (Array.isArray(tech)) return tech.filter(Boolean);
  if (typeof tech === 'string') {
    return tech.split(',').map((t) => t.trim()).filter(Boolean);
  }
  return [];
};
